/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SyncProfessionalRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    shiftManagerGroupIds: {
      type: 'array',
      contains: {
        type: 'string',
      },
      isRequired: true,
    },
  },
} as const;
